import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Profile from "../views/Profile.vue";
import Login from "../views/auth/Login.vue";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/login",
  }
  ,
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true,
      permissions: ['view stats', 'view dashboard', 'view-stats', 'view-dashboard']
    },
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { hideLayout: true }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requiresAuth: true },
  },
  {
    path: "/profile/contract",
    name: "Contract",
    component: () => import("../views/Contract.vue"),
    meta: { requiresAuth: true },
  },
  // Admin Contract routes
  {
    path: "/admin/contract-template",
    name: "MasterTemplate",
    component: () => import("../views/Admin/Contracts/MasterTemplate.vue"),
    meta: { requiresAuth: true, permissions: ['manage contracts', 'manage-contracts'] },
  },
  {
    path: "/admin/executed-contracts",
    name: "ExecutedContracts",
    component: () => import("../views/Admin/Contracts/ExecutedContracts.vue"),
    meta: { requiresAuth: true, permissions: ['view contracts', 'view-contracts'] },
  },
  {
    path: "/no-access",
    name: "NoAccess",
    component: () => import("../views/NoAccess.vue"),
    meta: { requiresAuth: true },
  },



  //country routes
  {
    path: "/countries",
    name: "Countries",
    component: () => import("../views/Countries/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/countries/create",
    name: "CountryCreate",
    component: () => import("../views/Countries/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/countries/:id/edit",
    name: "CountryEdit",
    component: () => import("../views/Countries/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },





  //users routes

  // Admin routes
  {
    path: "/admin/wallet/charge/:id",
    name: "AdminStudentCreditWallet",
    component: () => import("../views/Admin/StudentCreditWallet.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view wallets', 'view-wallets', 'manage wallets', 'manage-wallets', 'manage wallet', 'manage-wallet'] }
  },
  {
    path: "/admin/wallet/balance/:userId",
    name: "AdminStudentBalance",
    component: () => import("../views/Admin/StudentBalance.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view wallets', 'view-wallets', 'manage wallets', 'manage-wallets', 'manage wallet', 'manage-wallet'] }
  },


  // User routes (Admin)
  {
    path: "/admin/users",
    name: "UsersList",
    component: () => import("../views/Admin/Users.vue"),
    meta: { requiresAuth: true, permissions: ['view users', 'view-users'] }
  },
  {
    path: "/admin/users/:id/view",
    name: "UserView",
    component: () => import("../views/Admin/UserView.vue"),
    props: true,
    meta: { requiresAuth: true, permissions: ['view users', 'view-users'] },
  },
  {
    path: "/admin/moderators/create",
    name: "ModeratorCreate",
    component: () => import("../views/Admin/ModeratorCreate.vue"),
    meta: { requiresAuth: true, permissions: ['create users', 'create-users'] }
  },

  // Debug route (remove in production)
  {
    path: "/debug/permissions",
    name: "DebugPermissions",
    component: () => import("../views/Debug/UserPermissions.vue"),
    meta: { requiresAuth: true }
  },


  // New Model Routes
  {
    path: "/compounds",
    name: "Compounds",
    component: () => import("../views/Compounds/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/compounds/create",
    name: "CompoundCreate",
    component: () => import("../views/Compounds/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/compounds/:id/edit",
    name: "CompoundEdit",
    component: () => import("../views/Compounds/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/compounds/:id/view",
    name: "CompoundView",
    component: () => import("../views/Compounds/CompoundView.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/developers",
    name: "Developers",
    component: () => import("../views/Developers/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/developers/create",
    name: "DeveloperCreate",
    component: () => import("../views/Developers/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/developers/:id/edit",
    name: "DeveloperEdit",
    component: () => import("../views/Developers/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/areas",
    name: "Areas",
    component: () => import("../views/Areas/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/areas/create",
    name: "AreaCreate",
    component: () => import("../views/Areas/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/areas/:id/edit",
    name: "AreaEdit",
    component: () => import("../views/Areas/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/areas/:id/view",
    name: "AreaView",
    component: () => import("../views/Areas/View.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/properties",
    name: "Properties",
    component: () => import("../views/Properties/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/properties/create",
    name: "PropertyCreate",
    component: () => import("../views/Properties/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/properties/:id/edit",
    name: "PropertyEdit",
    component: () => import("../views/Properties/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/properties/:id/view",
    name: "PropertyView",
    component: () => import("../views/Properties/PropertyView.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  //banks routes
  {
    path: "/banks",
    name: "Banks",
    component: () => import("../views/Banks/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/banks/create",
    name: "BankCreate",
    component: () => import("../views/Banks/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/banks/:id/edit",
    name: "BankEdit",
    component: () => import("../views/Banks/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },

  //slides routes
  {
    path: "/slides",
    name: "SlideList",
    component: () => import("../views/Slides/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/slides/create",
    name: "SlideCreate",
    component: () => import("../views/Slides/Create.vue"),
    meta: { requiresAuth: true }
  },
  // compound brochures routes
  {
    path: "/compounds/:compoundId/brochures",
    name: "CompoundBrochureList",
    component: () => import("../views/CompoundBrochures/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/meeting-requests",
    name: "Meeting Requests",
    component: () => import("../views/MeetingRequests/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/meeting-requests/:id/edit",
    name: "MeetingRequestEdit",
    component: () => import("../views/MeetingRequests/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/learn-videos",
    name: "Learn Videos",
    component: () => import("../views/LearnVideos/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/learn-videos/create",
    name: "LearnVideoCreate",
    component: () => import("../views/LearnVideos/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/learn-videos/:id/edit",
    name: "LearnVideoEdit",
    component: () => import("../views/LearnVideos/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/learn-faqs",
    name: "Learn FAQs",
    component: () => import("../views/LearnFaqs/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/learn-faqs/create",
    name: "LearnFaqCreate",
    component: () => import("../views/LearnFaqs/Create.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/learn-faqs/:id/edit",
    name: "LearnFaqEdit",
    component: () => import("../views/LearnFaqs/Edit.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/leads",
    name: "Leads",
    component: () => import("../views/Leads/List.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/leads/:id",
    name: "LeadView",
    component: () => import("../views/Leads/View.vue"),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: "/lead-stage-requests",
    name: "LeadStageApprovalRequests",
    component: () => import("../views/Leads/StageApprovalRequests.vue"),
    meta: { requiresAuth: true }
  },
];
const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

export default router;
